import { render, staticRenderFns } from "./IcoLink.vue?vue&type=template&id=2f2a1ba5"
import script from "./IcoLink.vue?vue&type=script&lang=js"
export * from "./IcoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports